import { z } from 'zod';
import api from '~/utils/api';
import { ClaimType } from '~/utils/constants';
import {
  makeDraftClaimLineItemWithReasonAction,
  makeDraftClaimLineItemWithReasonLoader,
  redirect,
} from '~/utils/routing';

const paramsSchema = z.object({
  idFromPlatform: z.string(),
  claimType: z.nativeEnum(ClaimType),
  store: z.string(),
});

export const { loader, useLoaderData } = makeDraftClaimLineItemWithReasonLoader(
  ({ context, params }) => {
    const {
      draftClaimLineItem,
      settings: { storefrontId },
      order,
    } = context;
    const { claimType, store } = paramsSchema.parse(params);

    return api
      .calculateAfterReasonSelection({
        params: { storefrontId },
        body: {
          id: draftClaimLineItem.lineItem.id,
          claimType,
          calculatedLineItems: [
            {
              originalStoreOrderLineItem: {
                name: draftClaimLineItem.lineItem.name,
                imgUrl: draftClaimLineItem.lineItem.imgUrl,
                optionsFromPlatform:
                  draftClaimLineItem.lineItem.optionsFromPlatform,
              },
              originalStoreOrderLineItemId: draftClaimLineItem.lineItem.id,
              quantity: draftClaimLineItem.quantity,
              grams: draftClaimLineItem.grams,
              unitPrice: draftClaimLineItem.unitPrice,
              unitTax: draftClaimLineItem.unitTax,
              comments: draftClaimLineItem.comments,
              reasonId: draftClaimLineItem.reasonId,
              reasonCategoryCode: draftClaimLineItem.reasonCategoryCode,
              reasonDetailId: draftClaimLineItem.reasonDetailId,
              advancedExchangeMethod: draftClaimLineItem.advancedExchangeMethod,
            },
          ],
        },
      })
      .then(({ eventPolicyEnforcement }) =>
        eventPolicyEnforcement ?
          {
            eventPolicyEnforcement,
            orderId: order.idFromPlatform,
            claimType,
            store,
          }
          // return a redirect with the event custom fields if it exists
        : redirect('../meta'),
      );
  },
);

export const { action, useActionResult } =
  makeDraftClaimLineItemWithReasonAction(({ context }, appStore) =>
    api
      .confirmAfterReasonSelection({
        params: { storefrontId: context.settings.storefrontId },
        query: {
          originalStoreOrderLineItemId: context.draftClaimLineItem.lineItem.id,
        },
      })
      .then(() => {
        // item not eligible for return
        appStore.dispatch(
          appStore.actions.invalidateLineItem(context.draftClaimLineItem.id),
        );

        return {
          ok: true,
        };
      })
      .catch(() => ({ ok: false })),
  );

// the action clears the draft claim line item, so we don't want to revalidate the loader
export const shouldRevalidate = () => false;
